import { requestCommon, requestMain } from '@/apis';
import { getToken } from '@/apis/util';
import { buildRequestHeaders } from '@/utils/gray-config';
import type { PoiCheckRequest, PoiCheckResponse } from './type';

export function calcPrice(data: any) {
  return requestMain(
    '',
    {
      showError: false,
      method: 'post',
      headers: buildRequestHeaders(),
      params: {
        _m: 'order_price_calculate',
        one_price_enterprise_version: 2, // 企业多因素一口价标识版本
        os: 'ep',
        token: getToken(), // 蜜罐需求后端接口要求新增token传参
      },
      data: {
        ...data,
        one_price_enterprise_version: 2,
        type: 3,
      },
    },
    true
  );
}


type OrderPaySatusType = {
  order_uuid: string;
  type: number;
};
// 查询支付状态
export function getOrderPayStatus(data: OrderPaySatusType) {
  return requestMain('', {
    method: 'POST',
    params: {
      _m: 'order_pay_status',
    },
    data,
  });
}

// 保险协议、文本
export function getPolicyText() {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'order.insurance.agreement.text',
      },
    },
    true,
    'eoc'
  );
}

// 获取优质司机服务数据
export function qualityServiceInfoApi(data: any) {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'price.calculate.config.info',
        data,
      },
    },
    true,
    'eoc'
  );
}

/**
 * POI 地址校验接口
 * 用于再来一单时校验地址是否有更新
 * @param data PoiCheckRequest
 * @returns PoiCheckResponse
 */
export function poiCheckApi(data: PoiCheckRequest): Promise<PoiCheckResponse> {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'order.address.poi.check',
        data,
      },
    },
    true,
    'eoc'
  );
}
